module.exports = __webpack_public_path__ + "static/media/RequestService.98db2772.png";